<template>
	<div class="container">
		<!-- Payment Method -->
		<div class="section" v-if="displayPayment">
			<PaymentMethod @updatePayment="updatePayment()"></PaymentMethod>
		</div>
		<!-- Payment Method -->

		<div v-if="displayConfirmNotes" class="confirm-notes-section">
			<div class="header">
				<div class="flex-between">
					<div class="title">
						{{ i18n.t('order.ordering') }}
					</div>
					<div>
						<img src="@/assets/image/tab/home.gif" class="app-icon" />
					</div>
				</div>
			</div>
			<!-- Payment tips -->
			<div>
				<div v-for="(note, index) in notes" :key="index" class="note">
					<div>
						<img src="@/assets/image/svg/animation-checked.svg" class="icon" />
					</div>
					<div class="message">{{ note }}</div>
				</div>
			</div>
			<!-- Payment tips -->

			<div class="footer">
				<mt-button
					class="ds-button-large common-btn"
					type="primary"
					@click.native="cancel()"
					>{{ i18n.t('order.checkout_regret') }}</mt-button
				>
			</div>
		</div>
	</div>
</template>

<script>
import PaymentMethod from './util/PaymentMethod'
import store from '@/store'
import i18n from '@/i18n'
import router from '@/router'
import { required, requiredIf, integer, decimal } from 'vuelidate/src/validators'
import validator from '@/util/validator'
import { ErrandOrderType } from '@/const/order'
import { PayType } from '@/const/payment'
import { buyStep2 } from '@/api/memberBuy'
import { addErrandOrder } from '@/api/memberO2oErrand'
import { pay } from '@/api/memberPayment'

export default {
	name: 'PaymentConfirm',
	validations: {
		createOrderPayload: {
			orderType: {
				required,
				inArray: function (val) {
					return (
						[ErrandOrderType.BUY, ErrandOrderType.SEND].find(
							(v) => v === val
						) !== undefined
					)
				}
			},
			// for errand order buy
			hasShoppingCart: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				}),
				isBoolean: validator.isBoolean
			},
			soldOutOption: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			cartIds: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			addressId: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			vatHash: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			paymentCode: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			paymentId: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			payMessage: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			expectTime: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.BUY
				})
			},
			// for errand order send
			o2o_errand_order_appointment_time: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_check_receive: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			},
			o2o_errand_order_deliver_address: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_deliver_lat: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				decimal
			},
			o2o_errand_order_deliver_lng: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				decimal
			},
			o2o_errand_order_deliver_name: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_deliver_phone: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				isMobile: validator.mobile
			},
			o2o_errand_order_deliver_region_id: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			},
			o2o_errand_order_detail: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_goods_price: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			},
			o2o_errand_order_gratuity: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			},
			o2o_errand_order_if_pay_on_behalf: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				isBoolean: validator.isBoolean
			},
			o2o_errand_order_pay_on_behalf_amount: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			},
			o2o_errand_order_pickup_address: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_pickup_lat: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				decimal
			},
			o2o_errand_order_pickup_lng: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				decimal
			},
			o2o_errand_order_pickup_name: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_pickup_phone: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_pickup_region_id: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			},
			o2o_errand_order_remark: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				})
			},
			o2o_errand_order_type: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			},
			o2o_errand_order_weight: {
				required: requiredIf(function (createOrderPayload) {
					return createOrderPayload.orderType === ErrandOrderType.SEND
				}),
				integer
			}
		},
		paymentDetail: {
			serialNumber: {
				required
			},
			paymentCode: {
				required
			},
			orderType: {
				required,
				inArray: function (val) {
					return (
						[ErrandOrderType.BUY, ErrandOrderType.SEND].find(
							(v) => v === val
						) !== undefined
					)
				}
			}
		},
		requestPaymentPayload: {
			serialNumber: {
				required
			},
			paymentCode: {
				required
			},
			token: {
				required
			},
			payType: {
				required,
				inArray: function (val) {
					return (
						[PayType.PAY_NEW, PayType.O2O_ERRAND_PAY_NEW].find(
							(v) => v === val
						) !== undefined
					)
				}
			}
		}
	},
	props: {
		choosePayment: {
			type: Boolean,
			require: false,
			default: false
		},
		paymentDetail: {
			type: Object,
			require: false
		},
		sellOutOption: {
			type: String,
			require: false,
			default: 'remove_item'
		},
		createOrderPayload: {
			type: Object,
			require: false
		},
		interval: {
			type: Number,
			require: false,
			default: 5000
		}
	},
	components: {
		PaymentMethod
	},
	data () {
		return {
			i18n,
			checkoutTimer: undefined,
			displayPayment: this.choosePayment,
			displayConfirmNotes: false,
			requestPaymentPayload: {
				paymentCode: undefined,
				serialNumber: undefined,
				token: undefined,
				payType: undefined
			}
		}
	},
	created () {
		try {
			if (this.createOrderPayload) {
				if (this.$v.createOrderPayload.$error) {
					throw new Error('The createOrderPayload validation error')
				}
			} else {
				if (this.$v.paymentDetail.$error) {
					throw new Error('The paymentDetail validation error')
				}
			}
			if (!this.choosePayment) {
				this.checkout()
			}
		} catch (e) {
			const validation = this.$v.createOrderPayload.$error ? this.$v.createOrderPayload : this.$v.paymentDetail
			console.error(e)
			console.log(this.createOrderPayload)
			for (const [key, value] of Object.entries(validation)) {
				if (!key.startsWith('$') && value.$error) {
					console.error('Validation error:', key, value)
				}
			}
			this.$alert.error(i18n.t('errors.runtime_error'))
			this.cancel()
		}
	},
	computed: {
		token: function () {
			return store.state.member.token || undefined
		},
		notes: function () {
			if (this.isErrandBuy) {
				return [
					i18n.t(`order.checkout_confirm.sell_out.${this.sellOutOption}`),
					i18n.t('order.checkout_confirm.note'),
					i18n.t('order.checkout_confirm.redirect_payment_when_order_created')
				]
			} else if (this.isErrandSend) {
				return [
					i18n.t('order.checkout_confirm.keep_connect'),
					i18n.t('order.checkout_confirm.redirect_payment_and_matching_deliver')
				]
			}
			return []
		},
		orderType: function () {
			if (this.createOrderPayload && this.createOrderPayload.orderType !== undefined) {
				return this.createOrderPayload.orderType
			} else if (this.paymentDetail && this.paymentDetail.orderType !== undefined) {
				return this.paymentDetail.orderType
			}
			return undefined
		},
		payType: function () {
			if (this.orderType === undefined) {
				return undefined
			}
			return {
				[ErrandOrderType.BUY]: PayType.PAY_NEW,
				[ErrandOrderType.SEND]: PayType.O2O_ERRAND_PAY_NEW
			}[this.orderType]
		},
		paySn: function () {
			if (this.requestPaymentPayload && this.requestPaymentPayload.serialNumber !== undefined) {
				return this.requestPaymentPayload.serialNumber
			} else if (this.paymentDetail && this.paymentDetail.serialNumber !== undefined) {
				return this.paymentDetail.serialNumber
			}
			return undefined
		},
		paymentCode: function () {
			if (this.createOrderPayload && this.createOrderPayload.paymentCode !== undefined) {
				return this.createOrderPayload.paymentCode
			} else if (this.paymentDetail && this.paymentDetail.paymentCode !== undefined) {
				return this.paymentDetail.paymentCode
			}
			return 'credit_h5'
		},
		isErrandBuy: function () {
			return this.orderType === ErrandOrderType.BUY
		},
		isErrandSend: function () {
			return this.orderType === ErrandOrderType.SEND
		}
	},
	methods: {
		goNext () {
			router.push({ name: 'MemberOrderList' })
		},
		cancel () {
			clearTimeout(this.checkoutTimer)
			this.checkoutTimer = undefined
			this.displayPayment = false
			this.displayConfirmNotes = false
			this.$emit('cancelPayment')
			store.dispatch('closePaymentConfirmModal')
		},
		createOrder () {
			return new Promise(async (resolve, reject) => {
				try {
					if (this.$v.createOrderPayload.$error) {
						throw new Error('The createOrderPayload validation error')
					}

					const payload = Object.assign({}, this.createOrderPayload)
					delete payload.orderType
					let paySn

					if (this.isErrandBuy) {
						const res = await buyStep2(this.createOrderPayload)
						paySn = res.result.pay_sn
					} else {
						const res = await addErrandOrder(this.createOrderPayload)
						paySn = res.result.pay_sn
					}
					resolve(paySn)
				} catch (err) {
					reject(err)
				}
			})
		},
		checkout () {
			const _this = this
			this.displayConfirmNotes = true
			this.displayPayment = false
			_this.checkoutTimer = setTimeout(async () => {
				try {
					if (_this.createOrderPayload && !_this.$v.createOrderPayload.$error) {
						_this.requestPaymentPayload.serialNumber = await _this.createOrder()
					}
					_this.requestPaymentPayload = Object.assign({}, {
						serialNumber: this.paySn,
						paymentCode: this.paymentCode,
						token: this.token,
						payType: this.payType
					})
					const res = await _this.payment()
					store.dispatch('clearShopInfo')
					if (!res.code) {
						if (!window.nativePostMessage) {
							document.write(res)
							return
						}
						_this.goNext()
						window.nativePostMessage({
							type: 'webview-modal',
							visible: true,
							title: i18n.t('general.payment'),
							source: {
								html: res
							}
						})
					} else {
						_this.goNext()
					}
				} catch (err) {
					console.error(err)
					_this.$alert.error(i18n.t('errors.runtime_error'))
					_this.cancel()
				} finally {
					_this.cancel()
				}
			}, _this.interval)
		},
		updatePayment () {
			this.checkout()
		},
		payment () {
			return new Promise((resolve, reject) => {
				if (this.$v.requestPaymentPayload.$error) {
					return reject(new Error('The requestPaymentPayload validation error'))
				}
				pay(
					this.requestPaymentPayload.serialNumber,
					this.requestPaymentPayload.payType,
					{
						payment_code: this.paymentCode
					},
					this.requestPaymentPayload.token
				)
					.then((res) => {
						if (!res.code) {
							resolve(res)
						}
						if (res.code === 10000 || res.code === 12001) {
						    resolve(res)
						} else {
							reject(new Error(res.message))
						}
					})
					.catch((err) => {
						reject(err)
					})
			})
		}
	},
	beforeDestroy: function () {
		this.cancel()
	}
}
</script>

<style lang='scss' scoped>
.container {
	height: inherit;
	width: inherit;
	background: #f4c41e;
	border-top-right-radius: 35px;
	border-top-left-radius: 35px;

	.section {
		flex-direction: column;
		padding: 0.8rem;
	}
}

.confirm-notes-section {
	height: 80vh;
	margin: 0.5rem 0.3rem;
	background: #f4c41e;
	border-top-right-radius: 35px;
	border-top-left-radius: 35px;
	bottom: 0;
	left: 0;
	right: 0;
}

.confirm-notes-section .header {
	margin: 0.5rem;
}

.confirm-notes-section .header .flex-between {
	align-items: center;
}

.flex-between {
	display: flex;
	justify-content: space-between;
}

.confirm-notes-section .header .title {
	font-size: $h1;
	font-weight: 900;
}

.confirm-notes-section .header .app-icon {
	padding: 1rem 0rem;
	width: 4rem;
}

.confirm-notes-section .footer {
	position: fixed;
	bottom: 5rem;
	width: 100%;
	margin: 0;
	display: flex;
	justify-content: center;
	align-items: center;
}

.confirm-notes-section .note {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 1rem;
}

.confirm-notes-section .note .icon {
	width: 2rem;
	height: 2rem;
	padding: 0rem 1rem;
}

.confirm-notes-section .note .message {
	font-size: $subFontSize;
	letter-spacing: 0.1rem;
	line-height: 1rem;
}

.mint-popup {
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}
</style>
